import { Box, Flex, Heading, Select } from '@chakra-ui/react';
import moment from 'moment';
import DataTable from 'react-data-table-component';
import Loader from '../../Loader';
import { LogTTEPengetahuan } from '../../../../../entities/LogTTEPengetahuan';
import { useLogTtePengetahuan } from './useLogTtePengetahuan';
import { getStatusLogTte } from './logTteStatus';

const ACTIVITY_LABEL = { PESERTA: 'Peserta', PEMATERI: 'Pemateri' };

const STATUS_CLASS = {
  processing: 'bg-blue-100 text-blue-800',
  stale: 'bg-red-100 text-red-800',
  done: 'bg-green-100 text-green-800',
  failed: 'bg-red-100 text-red-800',
  partial: 'bg-yellow-100 text-yellow-800',
};

const customStyles = {
  headCells: {
    style: {
      backgroundColor: '#F2FFFB',
      fontWeight: '600',
      fontSize: '13px',
    },
  },
};

const StatusBadge = ({ row }: { row: LogTTEPengetahuan }) => {
  const status = getStatusLogTte(row);

  return (
    <span
      className={`${STATUS_CLASS[status.key]} text-xs font-semibold mr-2 px-2.5 py-0.5 rounded`}
    >
      {status.label}
    </span>
  );
};

const ActivityBadge = ({ note }: { note: string }) => (
  <span
    className={`${
      note === 'PEMATERI'
        ? 'bg-blue-100 text-blue-800'
        : 'bg-green-100 text-green-800'
    } text-xs font-semibold px-2.5 py-0.5 rounded`}
  >
    {ACTIVITY_LABEL[note] ?? note}
  </span>
);

/**
 * Tabel Log TTE Pengetahuan (terpisah dari Log TTE Pelatihan).
 * Data terbaru di atas, refresh otomatis selama ada proses berjalan.
 */
const LogTtePengetahuan = () => {
  const log = useLogTtePengetahuan();

  const columns: any = [
    {
      name: 'No.',
      selector: (row, index) => (log.page - 1) * log.perPage + (index + 1),
      width: '70px',
    },
    {
      name: 'Nama Pengetahuan',
      selector: (row) => row.title,
      wrap: true,
      minWidth: '200px',
    },
    {
      name: 'Aktivitas',
      cell: (row) => <ActivityBadge note={row.note} />,
      minWidth: '110px',
    },
    {
      name: 'Waktu Pelaksanaan',
      selector: (row) =>
        `${moment(row.jadwal_mulai).format('DD-MM-YYYY')} sd ${moment(
          row.jadwal_selesai
        ).format('DD-MM-YYYY')}`,
      wrap: true,
      minWidth: '150px',
    },
    {
      name: 'Waktu Generate TTE',
      selector: (row) => moment(row.created_at).format('DD-MM-YYYY HH:mm'),
      wrap: true,
      minWidth: '150px',
    },
    { name: 'Total', selector: (row) => row.total },
    { name: 'Di Proses', selector: (row) => row.diproses },
    { name: 'Berhasil', selector: (row) => row.berhasil },
    { name: 'Gagal', selector: (row) => row.gagal },
    {
      name: 'Status',
      cell: (row) => <StatusBadge row={row} />,
      wrap: true,
      minWidth: '170px',
    },
  ];

  return (
    <Box bg="white" p={5} borderRadius="lg" mb={5} shadow="lg">
      <Flex
        justify="space-between"
        align="center"
        mb={5}
        gridGap={3}
        wrap="wrap"
      >
        <Heading as="h4" fontSize="xl" fontWeight="semibold">
          Log TTE Pengetahuan
        </Heading>
        <Select
          maxW="220px"
          size="sm"
          aria-label="Filter aktivitas TTE"
          value={log.activity}
          onChange={(e) => log.changeActivity(e.target.value)}
        >
          <option value="">Semua Aktivitas</option>
          <option value="PESERTA">TTE Peserta</option>
          <option value="PEMATERI">TTE Pemateri</option>
        </Select>
      </Flex>
      <DataTable
        columns={columns}
        data={log.data}
        progressPending={log.isLoading}
        pagination
        paginationServer
        paginationTotalRows={log.totalRows}
        paginationDefaultPage={log.page}
        paginationResetDefaultPage={log.resetPagination}
        onChangeRowsPerPage={(newPerPage, page) => {
          log.setPage(page);
          log.setPerPage(newPerPage);
        }}
        onChangePage={log.setPage}
        customStyles={customStyles}
        progressComponent={<Loader />}
      />
    </Box>
  );
};

export default LogTtePengetahuan;
